/**
 * colori.js — tonalita' ricavate dal colore di un'agenda.
 *
 * PERCHE'
 * In agenda ogni medico ha il suo colore. La colonna lo usa sbiadito
 * come sfondo della fascia oraria, e l'appuntamento sopra deve essere
 * lo STESSO colore ma piu' marcato: cosi' si legge a colpo d'occhio di
 * chi e' quello slot senza inseguire l'intestazione della colonna.
 *
 * Prima l'appuntamento aveva un fondo lilla fisso, uguale per tutti i
 * medici: il colore c'era solo nel filetto a sinistra, tre pixel.
 *
 * SI MESCOLA, NON SI CAMBIA OPACITA'. Un colore con l'alpha si compone
 * con quello che ha sotto, e sotto c'e' gia' la fascia colorata: il
 * risultato dipende dall'ordine di disegno e cambia da una colonna
 * all'altra. Mescolare produce un colore pieno, sempre lo stesso.
 */

/** '#aabbcc' oppure '#abc' -> {r,g,b}. Null se non e' un colore. */
function leggi(hex) {
    const s = String(hex || '').trim();
    const m3 = s.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
    if (m3) return { r: parseInt(m3[1] + m3[1], 16), g: parseInt(m3[2] + m3[2], 16), b: parseInt(m3[3] + m3[3], 16) };
    const m6 = s.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
    if (m6) return { r: parseInt(m6[1], 16), g: parseInt(m6[2], 16), b: parseInt(m6[3], 16) };
    return null;
}

const aDue = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, '0');

/**
 * Mescola un colore col bianco (`quanto` verso 1 = piu' chiaro) o col
 * nero (`quanto` negativo = piu' scuro).
 *
 * @param {string} hex     il colore dell'agenda
 * @param {number} quanto  da -1 (nero) a 1 (bianco)
 * @param {string} ripiego che cosa tornare se `hex` non e' leggibile
 */
export function mescola(hex, quanto, ripiego = '#cfd8dc') {
    const c = leggi(hex) || leggi(ripiego);
    if (!c) return ripiego;
    const verso = quanto >= 0 ? 255 : 0;
    const q = Math.abs(quanto);
    return '#' + aDue(c.r + (verso - c.r) * q)
               + aDue(c.g + (verso - c.g) * q)
               + aDue(c.b + (verso - c.b) * q);
}

/**
 * Bianco o nero, quello che si legge sopra questo colore.
 *
 * La soglia non e' la media dei tre canali: l'occhio pesa molto piu' il
 * verde del blu, e un blu scuro con la media alta resterebbe illeggibile
 * col testo nero.
 */
export function testoSopra(hex, chiaro = '#ffffff', scuro = '#2d3748') {
    const c = leggi(hex);
    if (!c) return scuro;
    const luminanza = (0.299 * c.r + 0.587 * c.g + 0.114 * c.b) / 255;
    return luminanza > 0.62 ? scuro : chiaro;
}
